export const GET_DASHBOARD_DETAILS_REQUEST = "GET_DASHBOARD_DETAILS_REQUEST";
export const GET_DASHBOARD_DETAILS_SUCCESS = "GET_DASHBOARD_DETAILS_SUCCESS";
export const GET_DASHBOARD_DETAILS_FAILURE = "GET_DASHBOARD_DETAILS_FAILURE";
